import { Box } from '@mui/material'
import { FC, ReactNode } from 'react'

import { NavItem } from './NavItem'
import { SidebarOverlay } from './SidebarOverlay'
import { NavModule } from './types'

type ModuleFlyoutProps = {
    modules: NavModule[]
    getCountForModule: (moduleId: string) => number | undefined
    onRef?: (ref: HTMLDivElement | null) => void
    label?: ReactNode
}

export const ModuleFlyout: FC<ModuleFlyoutProps> = ({
    modules,
    getCountForModule,
    onRef,
    label,
}) => {
    return (
        <SidebarOverlay onRef={onRef} label={label}>
            <Box sx={{ py: 2 }}>
                {modules.map((navModule, index) => (
                    <NavItem
                        key={navModule.id}
                        item={navModule}
                        label={navModule.label}
                        count={getCountForModule(navModule.id)}
                        showSeparator={navModule.separatorBefore && index > 0}
                    />
                ))}
            </Box>
        </SidebarOverlay>
    )
}
